export default "/WebApp/dist/assets/fonts/primeicons.ttf";